exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countries-page {\n  width: 100%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.countries-page__content {\n  display: flex;\n  padding: 64px 32px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.load-file-panel {\n  display: flex;\n  justify-content: center;\n}\n.download-focus {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #dbdbdb;\n  background-color: #fff;\n  width: 70vw !important;\n  height: 132px !important;\n  font-size: 32px !important;\n  margin-top: 1rem;\n}\n.download-focus span {\n  margin-left: 8px;\n}\n.load-file-button {\n  width: 70vw !important;\n  height: 132px !important;\n  font-size: 32px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Countries/containers/countries.less
// module id = 893
// module chunks = 0